import { ETipoOperacao } from '../../pix/models/qr-code-return.model';
import { TransactionType } from '../extract.model';

export class Record {
	date: any;
	dateHour: Date;
	description: string;
	name: string;
	value: number;
	balance: number;
	mode: string;
	hasBalance: boolean;
	transactionType: TransactionType;
	isPix = false;
	isPixDevolution = false;
	pixOpenFinance = false;
	isInfration: boolean;
	operationType?: ETipoOperacao;
	devSpecialMecan = false;

	constructor() { }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/extract/models/record.ts